export const iconFontAwesomeCodingTerminal = (
	<i className="fa-solid fa-terminal"></i>
);
